import {React, useLocalStore, observer, useEffect, classNames, Popover2} from '@api'

import {Tooltip} from '@material-ui/core'
import {FieldRendererStore, useFieldRendererStore} from '@design-board/stores'
import {useCatalogItemSidebarDetailsStore} from '@modules'
import {PrimaryIconButton} from 'centric-ui-components'
import {action, observable, autorun, computed} from 'mobx'
import {Fragment, useContext} from 'react'
import * as css from './Emersya3dViewer.css'
import {Button, Popover, Menu, MenuItem, MenuDivider, Icon} from '@blueprintjs/core'
import {onSiteError, StoresInstance} from '@stores'
import {VipLocalStore} from '@modules'
import { Tooltip2 } from '@api'

export interface EmersyaViewerProps {
  className?: string,
  selectedModel?: any
  onLoadStore?: (store: EmersyaViewerStore) => void
}

namespace Emersya {
  export type Annotation = {
    annotationId?: number
    number: number
    title: string
    description: string
  }

  export namespace Messages {
    export type Start = { data: { action: 'onStart' } }
    export type Screenshot = { data: { action: 'onScreenshot', id?: string, screenshot: string }  }
    export type StateChange = {
      data: {
          action: 'onStateChange', id?: string, state: {
            arCompatibility?: boolean
            arState?: any
            loadingProgress?: number
            version: { routeViewer: number, routeProject: number, actualViewer: number, actualProject: number, loadedFromConfiguration: boolean }
            viewerState: 'loading' | unknown
            viewerType: 'webgl' | unknown
            webglStatus?: number
          }
      }
    }
    export type SavedConfiguration = {
      data: {
          action: 'onSavedConfiguration',
          id: number
          code: string

      }
    }

    export type PolylistSelection = {
      data: {
        action: 'onPolylistSelection',
        nodeId: string,
        position: any

      }
    }

    export type AnnotationOpened = {
      data: {
          action: 'onAnnotationOpened',
          annotationNumber: number

      }
    }

    export type AnnotationPinOpened = {
      data: {
          action: 'onAnnotationPinOpened',
          annotationNumber: number

      }
    }

    export type AnnotationClicked = {
      data: {
        action: 'onAnnotationClicked',
        annotationNumber: number
      }
    }

    export type Success = {
      data: {
          action: 'onSuccess',
          callAction: string
          id?: string

      }
    }
  }

  export type WindowMessage = Messages.Start | Messages.Screenshot | Messages.StateChange

  export type SaveConfigurationPayload = { id?: number, screenshot?: boolean, shortLink?: boolean, metadata?: any }

  export type AddAnnotationPinPayload = Annotation & {
    /**
     * Define if the annotation pin position will be set by the next click on the 3D viewer
     */
    onNextClick?: boolean
    nodeId?: boolean

    /**
     * Table containing the x, y, z values of the annotation pin position
     */
    position?: Array<number>
  }

  export type ShowAnnotationPinPayload = {
    number?: number
  }

  export type RemoveAnnotationPinPayload = {
    annotationId: number,
  }

  export type SetCameraPayload = {
    fov: number
    transitionTime: number
    position: number[]
    target: number[]
    up: number[]
    cameraControl?: any
  }
}

/*

			var annotationManager = new function() {
				var self = this;
				this.myAnnotationId  = null;
				this.isInAnnotationMode = false;
				var activateAnnotationMode = function() {
					self.isInAnnotationMode = true;
					document.getElementById('addAnnotation').style.backgroundColor = 'grey';
				};
				var desactivateAnnotationMode = function() {
					self.isInAnnotationMode = false;
					document.getElementById('addAnnotation').style.backgroundColor = '';
				};
				this.onAddAnnotationClicked = function() {
					activateAnnotationMode();
				};
				this.onRemoveAnnotationClicked = function() {
					desactivateAnnotationMode();
					if (!projectIsLoaded || (self.myAnnotationId === null)) {
						return;
					}
					messagePost({
						action       : 'removeAnnotationPin',
						annotationId : self.myAnnotationId
					});
					self.myAnnotationId = null;
				};
				this.addAnnotation = function (nodeId, position) {
					if (!projectIsLoaded || !self.isInAnnotationMode) {
						return;
					}
					if (self.myAnnotationId !== null) {
						messagePost({
							action       : 'removeAnnotationPin',
							annotationId : self.myAnnotationId
						}, function () {
							messagePost({
								action       : 'addAnnotationPin',
								annotationId : self.myAnnotationId,
								number       : 1,
								title        : 'Title',
								description  : 'Description',
								nodeId       : nodeId,
								position     : position
							});
						});
					} else {
						self.myAnnotationId = 0;
						messagePost({
							action       : 'addAnnotationPin',
							annotationId : self.myAnnotationId,
							number       : 1,
							title        : 'Title',
							description  : 'Description',
							nodeId       : nodeId,
							position     : position
						});
					}
					desactivateAnnotationMode();
				};
			};
			var msgListeners = {};
			var messagePost = (function() {
				var msgId = -1;
				return (function (data, cb) {
					data.id = msgId--;
					if (cb) {
						msgListeners[data.id] = cb;
					}
					appWindow.postMessage(data, '*');
				});
			})();
			var messageOn = function (ev) {
				if (!ev.data || !ev.data.action) {
					return;
				}
				var data = ev.data.action;
				switch (data.action) {
					case 'onStateChange': {
						if (data.state.viewerState === 'loaded') {
							onProjectLoaded();
						}
					} break;
					case 'onPolylistSelection': {
						if (annotationManager.isInAnnotationMode) {
							annotationManager.addAnnotation(data.nodeId, data.position);
						}
					} break;
				}
				if (msgListeners[data.id] !== undefined) {
					msgListeners[data.id](data);
					delete msgListeners[data.id];
				}
			};

 */

export class EmersyaViewerStore extends VipLocalStore {
  @observable.ref selectedModel
  @action selectModel = model => this.selectedModel = model ?? {}

  @observable overrideCode : string
  @observable message: string = ''
  @observable messageVisible = false

  @computed get menuButtons() {
    return <EmersyaViewerStoreContext.Provider value={this}>
      <EmersyaMenuButtons/>
    </EmersyaViewerStoreContext.Provider>
  }

  @computed get appAndCode() : string {
    const {store: {field: {field3d}}, selectedModel} = this

    const r = (selectedModel && field3d && _.get(selectedModel, field3d)) || '382AN2MPH8/CLTZEZ8HMR' // '772EABKZ94/4SPWR5TQHX' //'382AN2MPH8/CLTZEZ8HMR'
    //console.log(selectedModel, field3d, field3d && _.get(selectedModel, field3d), r)
    return r
  }

  @observable loaded = false
  @observable loading = false

  constructor(stores: StoresInstance,private store: FieldRendererStore, public props: EmersyaViewerProps) {
    super(stores)
    if (props.onLoadStore) {
      props.onLoadStore(this)
    }
    else {
      store.detailsStore.modal.emersya = this
    }
  }

  @action loadDefaultConfiguration = () => {
    //this.loadConfiguration(this.code)
  }

  @action loadConfiguration = (code: string) => {
    this.iframe.contentWindow.postMessage({
      action: 'loadConfiguration',
      code
    }, '*')
  }

  @action saveConfiguration = (params: Emersya.SaveConfigurationPayload) => {
    this.iframe.contentWindow.postMessage({
      action: 'saveConfiguration',
      ...params
    }, '*')
  }

  @action takeModelScreenshot = () => {
    this.iframe.contentWindow.postMessage({
      //action: 'getScreenshot',
      action: 'getForcedResolutionScreenshot',
      width: 1024,
      height: 1024
    }, '*')
    this.setMessageText('Taking screenshot...', 0)
  }

  private _onScreenshotTaken = async ({id, screenshot}) => {
    this.setMessageText('Screenshot taken')

    const {es, selectedModel, store: {catalog, field, detailsStore: {isOffline, index, data}}} = this

    if (field.screenshotsField) {
      const images3d = _.get(data, field.screenshotsField) ?? []
      _.set(data, field.screenshotsField, [...images3d, screenshot])
      //es.genericUpsert({index, _id: data._id, body: _.set({}, field.screenshotsField, images3d)})

      if (isOffline) {
        // mobx should have already seen the change and reserialized
      }
      else {
        await es.updateDocument({index, id: data._id, doc: _.set({}, field.screenshotsField, _.get(data, field.screenshotsField))})
      }
    }
    else if (selectedModel) {
      const mpv = data.exId ?? data._id,
        colorway = selectedModel.exId

      const _id = `${mpv}_${colorway}`,
        localData = catalog.getOfflineItem({index: 'vlp-3d-images', _id}),
        images3d = [...(selectedModel.images3d ?? []), ...(localData?.images3d ?? []), screenshot],
        rowValue = {
          _id,
          mpv,
          colorway,
          images3d
        }

      es.genericUpsert({
        _id,
        index: 'vlp-3d-images',
        body: _.omit(rowValue, '_id')
      })
      catalog.upsertOfflineItem({index: 'vlp-3d-images', value: rowValue})
      //selectedModel.images3d = images3d
    }
    else {
      console.warn(`No place to save 3d screenshot - define a screenshotField on the 3d detail view`)
    }

  }

  translateCameraY = (value: number) => {
    this.iframe.contentWindow.postMessage({
      action: 'translateCameraY',
      value
    }, '*')
  }

  moveCameraY = (value: number) => {
    this.iframe.contentWindow.postMessage({
      action: 'moveCameraY',
      value
    }, '*')
  }

  setCamera = (payload: Emersya.SetCameraPayload) => {
    this.iframe.contentWindow.postMessage({
      action: 'setCamera',
      ...payload
    }, '*')
  }

  private doZoomIn = (timeout = 500) => {
    const {iframe: {contentWindow}} = this
    contentWindow.postMessage({
      action: 'startZoomIn'
    }, '*')

    setTimeout(() => {
      contentWindow.postMessage({
        action: 'stopZoomIn'
      }, '*')
    }, timeout)
  }

  @action setMessageText = (msg: string, clearTimeout = 3000) => {
    this.message = msg
    this.messageVisible = msg != ''

    clearTimeout && setTimeout(() => {
      if (this.message == msg) {
        this.messageVisible = false
      }
    }, clearTimeout)
  }

  onMessage = (ev: MessageEvent & Emersya.WindowMessage) => {
    // console.log(ev)
    if (!ev.data || !ev.data.action || this.iframe.contentWindow != ev.source) {
      return
    }

    let data = this.useExternalUrl ? ev.data : ev.data.action // different versions of emersya have different APIs :(
    if (_.isObject(data.action)) {
      data = data.action
    }

    const {action} = data,
      {catalog} = this
    // console.log(ev, data)

    try {
      switch (action) {
        case 'onStateChange': {
          const {action, state: {viewerState, loadingProgress}} = data

          // console.log(`onStateChange`, viewerState)
          switch (viewerState) {
            case 'loading': {
              this.loading = true
              break
            }

            case 'loaded': {
              this.loaded = true

              this.setMessageText('Model loaded')
              break;
            }

            case 'opened': {
              //this.setCamera({fov: 35, position: [10.6, 1.5, 14.5], up: [0, 1, 0], target: [.175, -2, 1.6], transitionTime: 0})

              break
            }

            default: {
              break
            }
          }
          break
        }

        case 'onScreenshot': {
          const {id, screenshot} = data
          this._onScreenshotTaken({id, screenshot})

          break
        }

        case 'onSavedConfiguration': {
          this.onSavedConfiguration(data)
          break
        }

        /**
         * Fires when the user clicks somewhere in the 3d viewer on an item
         */
        case 'onPolylistSelection': {
          const {nodeId, position} = data

          this.lastSelection = {nodeId, position}

          if (this.annotationOnNextClick) {
            const number = this.nextAnnotationId - 2
            this.showAnnotationsPin()
            this.openAnnotationPin(number)
            this.setMessageText(`Created Annotation ${number}`)
          }

          break
        }

        case 'onAnnotationClicked': {
          const {annotationNumber} = data
          this.selectedAnnotation = annotationNumber
          break
        }

        case 'onSuccess': {
          const {id, callAction} = data

          if (!this.annotationOnNextClick && callAction == 'addAnnotationPin' && this.nextAnnotationId) {
            // Turn on the newly created annotation we made by specifying position (if next on click, this will be a different flow)
            this.openAnnotationPin(this.nextAnnotationId - 2)
            this.messageVisible = false
          }
          break
        }

        default: {
          //console.log(`Ignored ${ev.data.action.action}`, action)
          break
        }
      }


      // if (msgListeners[data.id] !== undefined) {
      //   msgListeners[data.id](data)
      //   delete msgListeners[data.id]
      // }
    } catch (err) {
      onSiteError(err)
    }
  }

  @observable.ref lastSelection: {nodeId, position}
  @observable selectedAnnotation : number

  iframe: HTMLIFrameElement
  onLoad = (e: React.SyntheticEvent<HTMLIFrameElement>) => {
    this.iframe = e.currentTarget
    const {iframe: {contentWindow}} = this
    this.loading = true
    window.addEventListener('message', this.onMessage)
    contentWindow.postMessage({action: 'registerCallback'}, '*')
  }

  @observable isFullScreen = false
  onFullScreenChange = () => this.isFullScreen = !this.isFullScreen

  @action toggleFullScreen = () => {
    this.iframe.requestFullscreen({navigationUI: 'show'})
  }

  private onSavedConfiguration = ({code}: { code: string }) => {
    const {selectedModel} = this
    selectedModel.configurations = [...(selectedModel.configurations ?? []), code]
  }

  // region Annotations

  @observable annotations:Array<Emersya.Annotation> =[]

  nextAnnotationId = 2
  annotationOnNextClick = false
  addAnnotationPin = (payload: Emersya.AddAnnotationPinPayload) => {
    this.annotationOnNextClick = payload.onNextClick

    console.log('addAnnotationPin', payload)
    this.iframe.contentWindow.postMessage({
      action: 'addAnnotationPin',
      ...payload
    }, '*')

    if (payload.onNextClick) {
      this.setMessageText('Click the Model to add an Annotation', 0)
    }
    this.nextAnnotationId++
  }

  showAnnotationPin = (payload: Emersya.ShowAnnotationPinPayload) => {
    const msg = {
      action: 'showAnnotationPin',
      ...payload
    }

    this.setMessageText('Showing annotations...')
    console.debug(msg)
    this.iframe.contentWindow.postMessage(msg, '*')
  }

  hideAnnotationsPin = () => {
    this.iframe.contentWindow.postMessage({
      action: 'hideAnnotationsPin'
    }, '*')

    this.setMessageText('Hiding annotations...')
  }

  showAnnotationsPin = () => {
    this.iframe.contentWindow.postMessage({
      action: 'showAnnotationsPin'
    }, '*')

    this.setMessageText('Showing annotations...')
  }

  openAnnotationPin = (number: number) => {
    this.iframe.contentWindow.postMessage({
      action: 'openAnnotationPin', number
    }, '*')
  }

  toggleAnnotationsPin = () => {
    console.debug(`toggleAnnotationsPin`)
    this.iframe.contentWindow.postMessage({
      action: 'toggleAnnotationsPin',
    }, '*')
  }

  removeAnnotationPin = (payload : Emersya.RemoveAnnotationPinPayload) => {
    const msg = {
      action: 'removeAnnotationPin',
      ...payload
    }
    console.debug(msg)

    this.iframe.contentWindow.postMessage(msg, '*')
  }

  // endregion

  @computed get field3d() { return this.store.value.valAsString }
  @computed get useExternalUrl() { return this.field3d && this.field3d.startsWith('http') }

}

export const EmersyaViewerStoreContext = React.createContext<EmersyaViewerStore>(undefined)
export const useEmersyaViewerStore = () => useContext(EmersyaViewerStoreContext)

const EmersyaMenuButtons = observer(() => {
  const {props, loaded, lastSelection, selectedAnnotation, nextAnnotationId, addAnnotationPin, showAnnotationsPin, hideAnnotationsPin, toggleAnnotationsPin, removeAnnotationPin, toggleFullScreen, takeModelScreenshot, saveConfiguration, selectModel, selectedModel, loadConfiguration, loadDefaultConfiguration} = useEmersyaViewerStore(),
    {data} = useCatalogItemSidebarDetailsStore()

  return (
    <div className={css.toolbar}>
      <Popover2 className={css.actionsPopover}
               key='actions'
               disabled={!loaded}
               position='bottom'

               content={<Menu>
                 <MenuItem text='Take Screenshot' disabled={!selectedModel} icon='camera' onClick={takeModelScreenshot}/>
                 <MenuDivider/>
                 <MenuItem text='Add Annotation' icon='saved' onClick={() => {
                   const title = prompt('Enter a title:'), description = prompt('Enter a description:')
                   addAnnotationPin({annotationId: nextAnnotationId, number: nextAnnotationId - 1, title, description, onNextClick: true}) ///*lastSelection == null, ...(lastSelection || {}*/)})
                 }}/>
                 <MenuItem text='Remove Annotation' icon='trash' disabled={!selectedAnnotation} onClick={() => removeAnnotationPin({annotationId: selectedAnnotation})}/>
                 <MenuDivider/>
                 <MenuItem text='Show Annotations' icon='eye-on' onClick={showAnnotationsPin}/>
                 <MenuItem text='Hide Annotations' icon='eye-off' onClick={hideAnnotationsPin}/>
                 {/*<MenuItem text='Toggle Annotations' icon='eye-on' onClick={toggleAnnotationsPin}/>*/}


                 <MenuDivider title='Configurations'/>
                 <MenuItem text='Save Configuration' disabled={!selectedModel} icon='saved' onClick={() => saveConfiguration({screenshot: true, metadata: {mpv: data.exId, colorway: selectedModel.i}})}/>
                 {!selectedModel?.configurations?.length ? undefined : <Fragment>
                   {selectedModel.configurations.map((code, i) => <MenuItem key={i} text={`Saved Config ${i + 1}`} onClick={() => loadConfiguration(code)}/>)}
                   <MenuItem text={`Reset ${selectedModel.name}`} icon='reset' onClick={loadDefaultConfiguration}/>
                 </Fragment>}
                 <MenuDivider/>
                 <MenuItem text='Full Screen' onClick={toggleFullScreen} icon='fullscreen'/>
               </Menu>}
      >
        <Button className={css.actionButton}
                disabled={!loaded} text='Actions' minimal={false} rightIcon='caret-down'/>
      </Popover2>

      {false && <div className={css.toolbarButtons}>
		  <Tooltip2 placement='bottom' content='Take Screenshot'>
			  <PrimaryIconButton icon={<Icon icon='camera'/>} onClick={takeModelScreenshot}/>
		  </Tooltip2>

		  <Tooltip2 placement='bottom' content='Save Configuration'>
			  <PrimaryIconButton icon={<Icon icon='saved'/>} onClick={() => saveConfiguration({screenshot: true, metadata: {mpv: data.exId, colorway: selectedModel.i}})}/>
		  </Tooltip2>

		  <Tooltip2 placement='bottom' content='Add Annotation'>
			  <PrimaryIconButton icon={<Icon icon='chat'/>}/>
		  </Tooltip2>

		  <Tooltip2 placement='bottom' content='Remove Annotation'>
			  <PrimaryIconButton icon={<Icon icon='trash'/>}/>
		  </Tooltip2>

		  <Tooltip2 placement='bottom' content='Full Screen'>
			  <PrimaryIconButton icon={<Icon icon='fullscreen'/>} onClick={toggleFullScreen}/>
		  </Tooltip2>
	  </div>}

      {!props.selectedModel && data?.style?.colorways?.length && <Popover2 className={css.actionsPopover}
	                                                                      position='bottom-right'
	                                                                      key='models'
	                                                                      content={<Menu>
                                                                            {data.style?.colorways?.map((model, i) => <MenuItem key={i} active={selectedModel == model} text={model.name} onClick={e => selectModel(model)}/>)}
                                                                          </Menu>}
	  >
		  <Button className={css.actionButton} text={selectedModel.name ?? 'Samples'} minimal={false} rightIcon='caret-down'/>
	  </Popover2>}
    </div>
  )
})


// WEBPACK FOOTER //
// ./src/modules/CatalogItemDetails/CatalogItemSidebarDetails/FieldRenderers/Emersya3dViewerStore.tsx